import { render } from "./addReduction.vue?vue&type=template&id=0970e309&scoped=true"
import script from "./addReduction.vue?vue&type=script&lang=js"
export * from "./addReduction.vue?vue&type=script&lang=js"

import "./addReduction.vue?vue&type=style&index=0&id=0970e309&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0970e309"]])

export default __exports__